/* eslint-disable complexity */
import { columnType } from 'components/table/types';
import _ from 'lodash';
import { BalanceStatus, BalanceType } from 'constants/balance.constants';
import { Box, Switch, useTheme, Stack, Typography } from '@mui/material';
import { formatDate, formatNumber, generalTranslation } from 'constants/global.constants';
import { tableColumns } from './tables.types';
import { CustomSwitch } from 'components/Inputs';
import { updateBenefitStatus, updateCompanyBenefitStatus } from 'services/benefits.service';

export const tableData = (data: any) => {
	return data?.map((item: any) => {
		return {
			...item,
			name: item?.name,
			type: item?.type,
			percentage: `${item?.percentage}%`,
			createdBy: item?.createdByBoUser?.firstName + ' ' + item?.createdByBoUser?.lastName,
		};
	});
};

export const buildColumns = (t: any, dispatch: any, canCreateBenefit: boolean): columnType[] => {
	const theme = useTheme();
	const columns: columnType[] = [];

	_.keys(tableColumns).map((element: any, index: number) => {
		let customValueHandle = {};

		if (element === 'isActive') {
			customValueHandle = {
				customValueHandle: (value: any, row: Record<string, any>) => {
					return (
						<Stack display="flex" direction={'row'} justifyContent={'space-between'} gap={10}>
							<CustomSwitch
								checked={new Date(row?.expirationDate) > new Date() && row?.isActive}
								theme={theme}
							>
								<Switch
									checked={new Date(row?.expirationDate) >= new Date() && row?.isActive}
									disabled={!canCreateBenefit || new Date(row?.expirationDate) <= new Date()}
									onChange={() => {
										if (canCreateBenefit) {
											dispatch(
												updateBenefitStatus({ benefitId: row.id, isActive: !row.isActive })
											);
										}
									}}
								/>
							</CustomSwitch>
						</Stack>
					);
				},
			};
		}
		if (element === 'type') {
			customValueHandle = {
				customValueHandle: (value: any, row: Record<string, any>) => {
					return <Typography>{t(`page.benefits_management.${_.camelCase(value)}`)}</Typography>;
				},
			};
		}

		const props: columnType = {
			fieldId: 'id',
			name: element,
			title: t('page.benefits_management.tables.benefits.field.' + element),
			type: tableColumns[element],
			sortable: true,
			...customValueHandle,
		};
		columns.push(props);
	});

	return columns;
};
